webpackJsonp([1],{

/***/ 185:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idb__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_idb__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      items: [{ icon: 'history', iconClass: 'grey lighten-1 white--text', title: 'Reset', subtitle: 'Refresh the app to get the latest version', action: this.resetApp }],
      snackbar: false,
      snackbarText: '',
      company: this.$store.getters.company,
      server: localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com',
      signoutInterval: localStorage.getItem('signoutInterval') !== null && localStorage.getItem('signoutInterval') !== undefined ? localStorage.signoutInterval : 0
    };
  },

  watch: {
    cameraQuality: function cameraQuality(val) {
      localStorage.setItem('cameraQuality', val);
    },
    company: function company(val) {
      this.$store.dispatch('checkCompany', val);
    },
    server: function server(val) {
      this.$store.dispatch('setURL', val);
      localStorage.setItem('remoteServer', val);
    }
  },
  methods: {
    resetApp: function resetApp() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            registration.unregister();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).then(function (boolean) {
        caches.delete('dms-cache').then(function (boolean) {
          window.location.reload(true);
        });
      });
    },
    clearApp: function clearApp() {
      var _this = this;

      this.snackbar = true;
      this.snackbarText = 'Clearing Data';
      __WEBPACK_IMPORTED_MODULE_1_idb___default.a.delete('dms-db').then(function () {
        _this.snackbar = true;
        _this.snackbarText = 'Data Cleared';
      });
    },
    setSignoutInterval: function setSignoutInterval() {
      this.$store.dispatch('setSignoutInterval', this.signoutInterval);
      localStorage.setItem('signoutInterval', this.signoutInterval);
    }
  }
});

/***/ }),

/***/ 187:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['company', 'emp'],
  data: function data() {
    return {
      value: '',
      companyValue: '',
      companyDialog: false,
      pinVisible: false,
      unauthorised: false,
      unauthorisedMsg: '',
      companyCharcodes: '',
      pinCharcodes: '',
      pinLength: 4
    };
  },
  created: function created() {
    if (this.emp !== undefined && this.setCompany !== null) {
      console.log(this.emp);
      console.log(this.company);
      var n = 0;
      while (n < this.company.length) {
        this.companyCharcodes = this.companyCharcodes + '#' + this.company.charCodeAt(n);
        n++;
      }
      n = 0;
      while (n < this.emp.length) {
        this.pinCharcodes = this.pinCharcodes + '#' + this.emp.charCodeAt(n);
        n++;
      }
      this.value = this.emp;
      // this.submitPin()
    } else if (this.company) {
      this.$store.dispatch('checkCompany', this.company);
      this.pinVisible = true;
      this.getPinLength();
    } else if (this.setCompany === null) {
      this.companyDialog = true;
      this.pinVisible = true;
    } else {
      this.getPinLength();
      this.pinVisible = true;
    }
  },
  mounted: function mounted() {
    this.$store.dispatch('checkLoginTime');
  },

  computed: {
    setCompany: function setCompany() {
      if (this.company !== undefined) {
        return this.company;
      } else {
        return this.$store.getters.company;
      }
    },
    url: function url() {
      return this.$store.getters.url;
    },
    autosignin: function autosignin() {
      if (this.company && this.emp) {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    value: function value(val) {
      if (val.length >= this.pinLength) {
        this.submitPin();
      }
    }
  },
  methods: {
    submitPin: function submitPin() {
      var _this = this;

      if (this.value.length >= this.pinLength) {
        this.unauthorised = false;
        __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/dms-service/getEmpFromPin.ajax.php', {
          company: this.companyCharcodes ? this.companyCharcodes : this.setCompany,
          pin: this.emp ? this.pinCharcodes : this.value,
          autosignin: this.autosignin
        }).then(function (response) {
          localStorage.setItem('company', response.data.company);
          _this.$store.dispatch('checkCompany', response.data.company);
          if (response.data.empID === -2) {
            _this.unauthorised = true;
            _this.unauthorisedMsg = 'You are not authorised to use T&A. Please contact your system administrator for assistance.';
            _this.value = '';
          } else if (response.data.empID !== undefined) {
            _this.$store.dispatch('signUserIn', response.data);
            _this.$router.push('/');
          } else {
            _this.value = '';
            _this.unauthorised = true;
            _this.unauthorisedMsg = 'There was a problem signing in. This may be because you used an invalid pin number.';
            _this.pinVisible = true;
          }
        }).catch(function (error) {
          console.log(error);
          _this.value = '';
          _this.unauthorised = true;
          _this.unauthorisedMsg = 'There was a problem signing in. Please check your internet connection and try again.';
          _this.pinVisible = true;
        });
      }
    },
    addDigit: function addDigit(digit) {
      this.value += digit;
    },
    removeDigit: function removeDigit() {
      this.value = this.value.slice(0, -1);
    },
    setCompanyValue: function setCompanyValue() {
      this.$store.dispatch('checkCompany', this.companyValue);
      this.companyDialog = false;
      this.getPinLength();
    },
    getPinLength: function getPinLength() {
      var _this2 = this;

      this.pinVisible = false;
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(this.url + '/dms-service/getPinLength.ajax.php', {
        company: this.companyCharcodes ? this.companyCharcodes : this.setCompany
      }).then(function (response) {
        if (response.data.pinLength) {
          _this2.pinLength = response.data.pinLength * 1;
          _this2.pinVisible = true;
        } else {
          _this2.pinVisible = true;
        }
      }).catch(function () {
        _this2.pinVisible = true;
      });
    }
  }
});

/***/ }),

/***/ 190:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store__ = __webpack_require__(35);






// import * as firebase from 'firebase'

__webpack_require__(282);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);

var opts = {
  theme: {
    dark: false,
    themes: {
      light: {
        primary: '#1e2d4f',
        secondary: '#424242',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  vuetify: new __WEBPACK_IMPORTED_MODULE_3_vuetify___default.a(opts),
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_5__store__["a" /* store */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  },
  created: function created() {
    var company = localStorage.getItem('company') !== null && localStorage.getItem('company') !== undefined ? localStorage.company : null;
    this.$store.dispatch('checkCompany', company);
    var url = localStorage.getItem('remoteServer') !== null && localStorage.getItem('remoteServer') !== undefined ? localStorage.remoteServer : 'https://cwelite.aquariusit.com';
    this.$store.dispatch('setURL', url);
    // window.addEventListener('visibilitychange', function () {
    //   if (!document.hidden) {
    //     window.location.reload()
    //   }
    // })
    // firebase.database().ref('appData/versions').once('value')
    //   .then(result => {
    //     const latestVersions = result.val()
    //     if (localStorage.getItem('db-version')) {
    //       const currentDbVersion = localStorage.getItem('db-version')
    //       if (latestVersions.db !== currentDbVersion) {
    //         console.log('Database outdated, clearing local storage')
    //         localStorage.removeItem('languages')
    //         localStorage.removeItem('disclaimerText')
    //         localStorage.setItem('db-version', latestVersions.db)
    //       }
    //     }
    //     if (latestVersions.app !== this.appVersion) {
    //       console.log('App outdated, need to update')
    //       this.$store.dispatch('appOutdated', true)
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
  },
  data: function data() {
    return {
      appVersion: '0.8.11'
    };
  }
});

/***/ }),

/***/ 193:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(38);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71cc6966_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(214);
function injectStyle (ssrContext) {
  __webpack_require__(194)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_71cc6966_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 194:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 214:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-navigation-drawer',{attrs:{"fixed":"","right":"","temporary":"","app":""},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',[_c('v-list-item',{attrs:{"router":"","to":"/","exact":""}},[_c('v-list-item-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("home")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Home")])],1)],1),_vm._v(" "),_c('v-list-item',{attrs:{"router":"","to":"/settings"}},[_c('v-list-item-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("settings")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Settings")])],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"mt-3"}),_vm._v(" "),(_vm.user !== null)?_c('v-list-item',{attrs:{"router":""},on:{"click":_vm.onLogout}},[_c('v-list-item-action',[_c('v-icon',{attrs:{"light":""}},[_vm._v("exit_to_app")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v("Log Out")])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-app-bar',{attrs:{"app":"","fixed":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_vm._v("\n      Document Management\n    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-app-bar-nav-icon',{attrs:{"right":""},on:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}})],1),_vm._v(" "),_c('v-alert',{staticStyle:{"position":"fixed","top":"60px","width":"100%","z-index":"100"},attrs:{"value":_vm.appOutdated,"color":"warning","icon":"history"}},[_vm._v("The application has an update available "),_c('v-btn',{attrs:{"color":"success","depressed":""},on:{"click":_vm.resetApp}},[_vm._v("Click here to update")])],1),_vm._v(" "),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 215:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hello__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Settings__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Signin__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AuthGuard__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__NotAuthGuard__ = __webpack_require__(279);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/Settings',
    name: 'Settings',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Settings__["a" /* default */]
  }, {
    path: '/',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hello__["a" /* default */],
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__AuthGuard__["a" /* default */]
  }, {
    path: '/signin/:company?/:emp?',
    name: 'SignIn',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Signin__["a" /* default */],
    props: true,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_6__NotAuthGuard__["a" /* default */]
  }]
}));

/***/ }),

/***/ 217:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__ = __webpack_require__(49);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca72f0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(260);
function injectStyle (ssrContext) {
  __webpack_require__(218)
}
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hello_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ca72f0c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 218:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 57,
	"./af.js": 57,
	"./ar": 58,
	"./ar-dz": 59,
	"./ar-dz.js": 59,
	"./ar-kw": 60,
	"./ar-kw.js": 60,
	"./ar-ly": 61,
	"./ar-ly.js": 61,
	"./ar-ma": 62,
	"./ar-ma.js": 62,
	"./ar-sa": 63,
	"./ar-sa.js": 63,
	"./ar-tn": 64,
	"./ar-tn.js": 64,
	"./ar.js": 58,
	"./az": 65,
	"./az.js": 65,
	"./be": 66,
	"./be.js": 66,
	"./bg": 67,
	"./bg.js": 67,
	"./bm": 68,
	"./bm.js": 68,
	"./bn": 69,
	"./bn.js": 69,
	"./bo": 70,
	"./bo.js": 70,
	"./br": 71,
	"./br.js": 71,
	"./bs": 72,
	"./bs.js": 72,
	"./ca": 73,
	"./ca.js": 73,
	"./cs": 74,
	"./cs.js": 74,
	"./cv": 75,
	"./cv.js": 75,
	"./cy": 76,
	"./cy.js": 76,
	"./da": 77,
	"./da.js": 77,
	"./de": 78,
	"./de-at": 79,
	"./de-at.js": 79,
	"./de-ch": 80,
	"./de-ch.js": 80,
	"./de.js": 78,
	"./dv": 81,
	"./dv.js": 81,
	"./el": 82,
	"./el.js": 82,
	"./en-au": 83,
	"./en-au.js": 83,
	"./en-ca": 84,
	"./en-ca.js": 84,
	"./en-gb": 85,
	"./en-gb.js": 85,
	"./en-ie": 86,
	"./en-ie.js": 86,
	"./en-il": 87,
	"./en-il.js": 87,
	"./en-nz": 88,
	"./en-nz.js": 88,
	"./eo": 89,
	"./eo.js": 89,
	"./es": 90,
	"./es-do": 91,
	"./es-do.js": 91,
	"./es-us": 92,
	"./es-us.js": 92,
	"./es.js": 90,
	"./et": 93,
	"./et.js": 93,
	"./eu": 94,
	"./eu.js": 94,
	"./fa": 95,
	"./fa.js": 95,
	"./fi": 96,
	"./fi.js": 96,
	"./fo": 97,
	"./fo.js": 97,
	"./fr": 98,
	"./fr-ca": 99,
	"./fr-ca.js": 99,
	"./fr-ch": 100,
	"./fr-ch.js": 100,
	"./fr.js": 98,
	"./fy": 101,
	"./fy.js": 101,
	"./gd": 102,
	"./gd.js": 102,
	"./gl": 103,
	"./gl.js": 103,
	"./gom-latn": 104,
	"./gom-latn.js": 104,
	"./gu": 105,
	"./gu.js": 105,
	"./he": 106,
	"./he.js": 106,
	"./hi": 107,
	"./hi.js": 107,
	"./hr": 108,
	"./hr.js": 108,
	"./hu": 109,
	"./hu.js": 109,
	"./hy-am": 110,
	"./hy-am.js": 110,
	"./id": 111,
	"./id.js": 111,
	"./is": 112,
	"./is.js": 112,
	"./it": 113,
	"./it.js": 113,
	"./ja": 114,
	"./ja.js": 114,
	"./jv": 115,
	"./jv.js": 115,
	"./ka": 116,
	"./ka.js": 116,
	"./kk": 117,
	"./kk.js": 117,
	"./km": 118,
	"./km.js": 118,
	"./kn": 119,
	"./kn.js": 119,
	"./ko": 120,
	"./ko.js": 120,
	"./ky": 121,
	"./ky.js": 121,
	"./lb": 122,
	"./lb.js": 122,
	"./lo": 123,
	"./lo.js": 123,
	"./lt": 124,
	"./lt.js": 124,
	"./lv": 125,
	"./lv.js": 125,
	"./me": 126,
	"./me.js": 126,
	"./mi": 127,
	"./mi.js": 127,
	"./mk": 128,
	"./mk.js": 128,
	"./ml": 129,
	"./ml.js": 129,
	"./mn": 130,
	"./mn.js": 130,
	"./mr": 131,
	"./mr.js": 131,
	"./ms": 132,
	"./ms-my": 133,
	"./ms-my.js": 133,
	"./ms.js": 132,
	"./mt": 134,
	"./mt.js": 134,
	"./my": 135,
	"./my.js": 135,
	"./nb": 136,
	"./nb.js": 136,
	"./ne": 137,
	"./ne.js": 137,
	"./nl": 138,
	"./nl-be": 139,
	"./nl-be.js": 139,
	"./nl.js": 138,
	"./nn": 140,
	"./nn.js": 140,
	"./pa-in": 141,
	"./pa-in.js": 141,
	"./pl": 142,
	"./pl.js": 142,
	"./pt": 143,
	"./pt-br": 144,
	"./pt-br.js": 144,
	"./pt.js": 143,
	"./ro": 145,
	"./ro.js": 145,
	"./ru": 146,
	"./ru.js": 146,
	"./sd": 147,
	"./sd.js": 147,
	"./se": 148,
	"./se.js": 148,
	"./si": 149,
	"./si.js": 149,
	"./sk": 150,
	"./sk.js": 150,
	"./sl": 151,
	"./sl.js": 151,
	"./sq": 152,
	"./sq.js": 152,
	"./sr": 153,
	"./sr-cyrl": 154,
	"./sr-cyrl.js": 154,
	"./sr.js": 153,
	"./ss": 155,
	"./ss.js": 155,
	"./sv": 156,
	"./sv.js": 156,
	"./sw": 157,
	"./sw.js": 157,
	"./ta": 158,
	"./ta.js": 158,
	"./te": 159,
	"./te.js": 159,
	"./tet": 160,
	"./tet.js": 160,
	"./tg": 161,
	"./tg.js": 161,
	"./th": 162,
	"./th.js": 162,
	"./tl-ph": 163,
	"./tl-ph.js": 163,
	"./tlh": 164,
	"./tlh.js": 164,
	"./tr": 165,
	"./tr.js": 165,
	"./tzl": 166,
	"./tzl.js": 166,
	"./tzm": 167,
	"./tzm-latn": 168,
	"./tzm-latn.js": 168,
	"./tzm.js": 167,
	"./ug-cn": 169,
	"./ug-cn.js": 169,
	"./uk": 170,
	"./uk.js": 170,
	"./ur": 171,
	"./ur.js": 171,
	"./uz": 172,
	"./uz-latn": 173,
	"./uz-latn.js": 173,
	"./uz.js": 172,
	"./vi": 174,
	"./vi.js": 174,
	"./x-pseudo": 175,
	"./x-pseudo.js": 175,
	"./yo": 176,
	"./yo.js": 176,
	"./zh-cn": 177,
	"./zh-cn.js": 177,
	"./zh-hk": 178,
	"./zh-hk.js": 178,
	"./zh-tw": 179,
	"./zh-tw.js": 179
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 241;

/***/ }),

/***/ 260:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"height":"100%"},attrs:{"no-gutters":""},on:{"click":function($event){_vm.timer > 0 ? _vm.timer = _vm.timerDefault : ''}}},[_c('v-col',{attrs:{"cols":"12","md":"6","offset-md":"3"}},[_c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{attrs:{"fluid":""}},[(_vm.timer > 0)?_c('p',{staticClass:"caption text-right"},[_vm._v("Auto signout in "+_vm._s(_vm.logoutCountdown))]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"headline text-center"},[_vm._v("Welcome "+_vm._s(_vm.fullname))]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":100}}),_vm._v(" "),_c('br'),_vm._v("\n         Loading...\n        ")],1):[(_vm.unacknowledgedFiles.length > 0)?_c('v-card',{staticClass:"card--flex-toolbar mb-2 rounded-xl"},[_c('v-app-bar',{attrs:{"flat":"","dense":"","dark":"","color":"red darken-1"}},[_c('v-toolbar-title',{staticClass:"body-2"},[_vm._v("Incomplete Items")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-chip',{attrs:{"dark":"","color":"white","small":"","outlined":""}},[_vm._v(_vm._s(_vm.unacknowledgedFiles.length))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-row',{staticClass:"text-center pa-2",attrs:{"no-gutters":""}},[(!_vm.activeUnacknowledgedFolder)?_vm._l((_vm.unacknowledgedFolders),function(folder,i){return _c('v-col',{key:i,attrs:{"cols":"4"}},[_c('v-card',{staticClass:"mt-2",attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","target":"_blank","large":"","icon":""},on:{"click":function($event){_vm.activeUnacknowledgedFolder = folder.folderName}}},[_c('v-badge',{attrs:{"color":"red","overlap":""},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',[_vm._v(_vm._s(folder.count))])]},proxy:true}],null,true)},[_vm._v(" "),_c('v-icon',{attrs:{"x-large":""}},[_vm._v("folder")])],1)],1),_vm._v(" "),_c('p',{staticClass:"text-center caption mb-0"},[_vm._v(_vm._s(folder.folderName))])],1)],1)}):(_vm.unacknowledgedFolders.length > 1)?_c('v-col',{attrs:{"cols":"4"}},[_c('v-card',{staticClass:"mt-3",attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","large":"","icon":""},on:{"click":function($event){_vm.activeUnacknowledgedFolder = null}}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("keyboard_backspace")])],1),_vm._v(" "),_c('p',{staticClass:"text-center caption mb-0"},[_vm._v("back")])],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredUnacknowledgedFiles),function(file,i){return _c('v-col',{key:i,attrs:{"cols":"4"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","target":"_blank","large":"","icon":""},on:{"click":function($event){return _vm.setActiveFile(file, 'unacknowledged')}}},[(!file.interactive)?_c('v-icon',{attrs:{"x-large":""}},[_vm._v("insert_drive_file")]):_c('v-icon',{attrs:{"x-large":""}},[_vm._v("mdi-file-sign")])],1),_vm._v(" "),_c('p',{staticClass:"text-center caption mb-0"},[_vm._v(_vm._s(file.item_name))]),_vm._v(" "),_c('p',{staticClass:"text-center body-1"},[_vm._v(_vm._s(file.filename)+"."+_vm._s(file.extension))])],1)],1)})],2)],1):_vm._e(),_vm._v(" "),(_vm.acknowledgedFiles.length > 0)?_c('v-card',{staticClass:"card--flex-toolbar rounded-xl mt-2"},[_c('v-app-bar',{attrs:{"flat":"","dense":"","dark":"","color":"green lighten-1"}},[_c('v-toolbar-title',{staticClass:"body-2"},[_vm._v("Completed Items")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-chip',{attrs:{"color":"white","small":"","outlined":""}},[_vm._v(_vm._s(_vm.acknowledgedFiles.length))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-row',{staticClass:"text-center pa-2",attrs:{"no-gutters":""}},[(!_vm.activeAcknowledgedFolder)?_vm._l((_vm.acknowledgedFolders),function(folder,j){return _c('v-col',{key:j,attrs:{"cols":"4"}},[_c('v-card',{staticClass:"mt-2",attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","target":"_blank","large":"","icon":""},on:{"click":function($event){_vm.activeAcknowledgedFolder = folder.folderName}}},[_c('v-badge',{attrs:{"color":"green","overlap":""},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',[_vm._v(_vm._s(folder.count))])]},proxy:true}],null,true)},[_vm._v(" "),_c('v-icon',{attrs:{"x-large":""}},[_vm._v("folder")])],1)],1),_vm._v(" "),_c('p',{staticClass:"text-center caption mb-0"},[_vm._v(_vm._s(folder.folderName))])],1)],1)}):(_vm.acknowledgedFolders.length > 1)?_c('v-col',{attrs:{"cols":"4"}},[_c('v-card',{staticClass:"mt-3",attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","large":"","icon":""},on:{"click":function($event){_vm.activeAcknowledgedFolder = null}}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("keyboard_backspace")])],1),_vm._v(" "),_c('p',{staticClass:"text-center caption mb-0"},[_vm._v("back")])],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredAcknowledgedFiles),function(file,j){return _c('v-col',{key:j,attrs:{"cols":"4"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-btn',{attrs:{"color":"primary","target":"_blank","large":"","icon":""},on:{"click":function($event){return _vm.setActiveFile(file, 'acknowledged')}}},[_c('v-icon',{attrs:{"x-large":""}},[_vm._v("insert_drive_file")])],1),_vm._v(" "),_c('p',{staticClass:"text-center caption mb-0"},[_vm._v(_vm._s(file.item_name))]),_vm._v(" "),(file.extension === '')?_c('div',[_c('p',{staticClass:"text-center body-1",staticStyle:{"margin-bottom":"0px"}},[_vm._v(_vm._s(file.filename)+"."+_vm._s(file.extension))]),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","justify-content":"center","align-items":"center"}},[_c('p',{staticClass:"text-center caption mb-0"},[_vm._v("Score:")]),_vm._v(" "),_c('div',[(file.PassFail == 'Pass')?_c('p',{staticClass:"text-center caption mb-0",staticStyle:{"color":"darkgreen"}},[_vm._v(_vm._s(_vm._f("formatPercentage")(file.percentage))+"%")]):_vm._e(),_vm._v(" "),(file.PassFail == 'Fail')?_c('p',{staticClass:"text-center caption mb-0",staticStyle:{"color":"darkred"}},[_vm._v(_vm._s(_vm._f("formatPercentage")(file.percentage))+"%")]):_vm._e()])])]):_c('div',[_c('p',{staticClass:"text-center body-1"},[_vm._v(_vm._s(file.filename)+"."+_vm._s(file.extension))])])],1)],1)})],2)],1):_vm._e()]],2)],1)],1),_vm._v(" "),_c('v-snackbar',{attrs:{"timeout":_vm.snackbarTimeout},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n    "),_c('v-btn',{attrs:{"dark":"","text":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1),_vm._v(" "),[_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"rounded":""}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Acknowledge Document")])]),_vm._v(" "),(_vm.activeFile !== null)?_c('v-card-text',[_vm._v("\n            By Submitting this form you are confirming you have "+_vm._s(['mp4', 'png', 'jpg', 'jpeg'].indexOf(_vm.activeFile.extension) !== -1 ? 'viewed' : 'read')+" and understood the file "+_vm._s(_vm.activeFile.filename)+"."+_vm._s(_vm.activeFile.extension)+"\n            "),_c('v-checkbox',{attrs:{"label":'I confirm that I have ' + (['mp4', 'png', 'jpg', 'jpeg'].indexOf(_vm.activeFile.extension) !== -1 ? 'viewed' : 'read') + ', understood and acknowledged this ' + (_vm.activeFile.extension === 'mp4' ? 'video' : (['png', 'jpg', 'jpeg'].includes(_vm.activeFile.extension) ? 'image' : 'document')) + '.'},model:{value:(_vm.confirmCheckbox),callback:function ($$v) {_vm.confirmCheckbox=$$v},expression:"confirmCheckbox"}})],1):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":"","disabled":_vm.confirmCheckbox === false},nativeOn:{"click":function($event){return _vm.acknowledgeFile($event)}}},[_vm._v("Submit")])],1)],1)],1)],_vm._v(" "),[_c('v-dialog',{attrs:{"persistent":"","max-width":"700px"},model:{value:(_vm.dialogQuiz),callback:function ($$v) {_vm.dialogQuiz=$$v},expression:"dialogQuiz"}},[_c('v-card',{attrs:{"rounded":""}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v("Connected Quiz")])]),_vm._v(" "),(_vm.activeFile !== null)?_c('v-card-text',[_vm._v("\n                            There is a quiz that has been attached to this document,\n                            "),_c('br'),_vm._v("\n                            Quiz Name: "),_c('strong',[_vm._v(_vm._s(_vm.activeFile.quiz_name))])]):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){_vm.dialogQuiz = false}}},[_vm._v("Take Quiz Later")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.takeQuizNow($event)}}},[_vm._v("Take Quiz Now")])],1)],1)],1)],_vm._v(" "),[_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.alertDialog),callback:function ($$v) {_vm.alertDialog=$$v},expression:"alertDialog"}},[_c('v-card',{attrs:{"rounded":""}},[_c('v-card-text',{staticStyle:{"white-space":"pre-wrap"}},[_vm._v(_vm._s(_vm.alertMessage))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},nativeOn:{"click":function($event){return _vm.confirmAlert($event)}}},[_vm._v("OK")])],1)],1)],1)],_vm._v(" "),[_c('v-dialog',{attrs:{"persistent":"","fullscreen":""},model:{value:(_vm.viewFileDialog),callback:function ($$v) {_vm.viewFileDialog=$$v},expression:"viewFileDialog"}},[_c('v-card',{attrs:{"rounded":"","color":"#1e2d4f"}},[_c('v-card-title',[_c('span',{staticClass:"headline",staticStyle:{"color":"#fff"}},[_vm._v("View "+_vm._s(_vm.activeFile && _vm.activeFile.extension === 'mp4' ? 'Video' : 'Document'))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"#fff","text":""},nativeOn:{"click":function($event){return _vm.closeViewFileDialog($event)}}},[_vm._v("Close")])],1),_vm._v(" "),(_vm.activeFile !== null)?_c('v-card-text',{staticStyle:{"padding-left":"0px","padding-right":"0px"}},[(_vm.activeFile.extension === 'jpg' && _vm.viewFileDialog === true)?_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":_vm.activeFile.fileref,"allowfullscreen":""}}):_vm._e(),_vm._v(" "),(_vm.activeFile.extension === 'jpeg' && _vm.viewFileDialog === true)?_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":_vm.activeFile.fileref,"allowfullscreen":""}}):_vm._e(),_vm._v(" "),(_vm.activeFile.extension === 'png' && _vm.viewFileDialog === true)?_c('img',{staticStyle:{"width":"100%","height":"auto"},attrs:{"src":_vm.activeFile.fileref,"allowfullscreen":""}}):_vm._e(),_vm._v(" "),(_vm.activeFile.extension === 'mp4' && _vm.viewFileDialog === true)?_c('video',{staticStyle:{"width":"100%","height":"auto"},attrs:{"controls":""}},[_c('source',{attrs:{"src":_vm.activeFile.fileref,"type":"video/mp4"}})]):_vm._e(),_vm._v(" "),(_vm.activeFile.extension === 'pdf')?_c('iframe',{staticStyle:{"width":"100vw","height":"calc(100vh - 120px)","border-color":"#1e2d4f"},attrs:{"id":"fileIframe","src":("/pdfjs-4.0.379-dist/web/viewer.html?file=" + (encodeURIComponent(_vm.activeFile.fileref)) + "#toolbar=0&pagemode=none")}}):_vm._e(),_vm._v(" "),(_vm.activeFile.extension === 'pdf')?_c('p',{staticClass:"text-center",staticStyle:{"color":"#fff"}},[_vm._v("If you are having trouble viewing this file "),_c('a',{staticStyle:{"color":"#fff"},attrs:{"href":_vm.activeFile.fileref,"target":"_blank"}},[_vm._v("click here")]),_vm._v(" to open it in a new tab.")]):_vm._e()]):_vm._e()],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__(185);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb36501a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__(262);
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cb36501a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 262:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[_c('v-flex',[_c('v-card',[_c('v-list',{attrs:{"two-line":"","subheader":""}},[_c('v-subheader',{attrs:{"inset":""}},[_vm._v("Settings")]),_vm._v(" "),_c('v-list-item',[_c('v-text-field',{attrs:{"label":"Company Code"},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}})],1),_vm._v(" "),_c('v-list-item',[_c('v-text-field',{attrs:{"label":"Remote Server"},model:{value:(_vm.server),callback:function ($$v) {_vm.server=$$v},expression:"server"}})],1),_vm._v(" "),_c('v-list-item',[_c('v-text-field',{attrs:{"label":"Auto Signout Interval (Minutes)","type":"number"},on:{"change":_vm.setSignoutInterval},model:{value:(_vm.signoutInterval),callback:function ($$v) {_vm.signoutInterval=$$v},expression:"signoutInterval"}})],1),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('v-list-item',{key:item.title,on:{"click":item.action}},[_c('v-list-item-avatar',[_c('v-icon',{class:[item.iconClass]},[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(item.subtitle))])],1)],1)})],2)],1)],1),_vm._v(" "),_c('v-snackbar',{model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v("\n    "+_vm._s(_vm.snackbarText)+"\n    "),_c('v-btn',{attrs:{"dark":"","text":""},nativeOn:{"click":function($event){_vm.snackbar = false}}},[_vm._v("Close")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 263:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543cc974_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__ = __webpack_require__(264);
var normalizeComponent = __webpack_require__(15)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_543cc974_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 264:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticStyle:{"height":"100%"},attrs:{"no-gutters":""}},[_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.companyDialog),callback:function ($$v) {_vm.companyDialog=$$v},expression:"companyDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("Company Code")]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Please enter your company code")]),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Company Code","autofocus":""},model:{value:(_vm.companyValue),callback:function ($$v) {_vm.companyValue=$$v},expression:"companyValue"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.companyValue.length < 1,"color":"green darken-1","text":""},nativeOn:{"click":function($event){return _vm.setCompanyValue()}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-col',{attrs:{"lg":"6","offset-lg":"3"}},[(_vm.pinVisible)?_c('v-card',{attrs:{"height":"100%"}},[_c('p',{staticClass:"headline text-center py-1 mb-0"},[_vm._v("Please Enter Your PIN Code")]),_vm._v(" "),(_vm.pinLength <= 4)?_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{staticClass:"text-center px-5 py-0",attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"3"}},[_c('v-icon',{class:this.value.length > 0 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 0 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-icon',{class:this.value.length > 1 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 1 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-icon',{class:this.value.length > 2 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 2 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"3"}},[_c('v-icon',{class:this.value.length > 3 ? 'green--text' : '',attrs:{"medium":""}},[_vm._v(_vm._s(this.value.length > 3 ? 'radio_button_checked' : 'radio_button_unchecked'))])],1)],1)],1):_c('v-container',{attrs:{"fluid":""}},[_c('v-text-field',{staticClass:"mx-6",attrs:{"label":"PIN Code","type":"password","maxlength":_vm.pinLength},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_vm._v(" "),_c('v-row',{staticClass:"text-center px-5 pb-5 ma-0"},[_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(1)}}},[_vm._v("1")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(2)}}},[_vm._v("2")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(3)}}},[_vm._v("3")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(4)}}},[_vm._v("4")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(5)}}},[_vm._v("5")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(6)}}},[_vm._v("6")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(7)}}},[_vm._v("7")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(8)}}},[_vm._v("8")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(9)}}},[_vm._v("9")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}}),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.addDigit(0)}}},[_vm._v("0")])],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"4"}},[_c('v-btn',{staticClass:"primary--text",attrs:{"fab":"","text":"","large":""},on:{"click":function($event){return _vm.removeDigit()}}},[_c('v-icon',[_vm._v("backspace")])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-snackbar',{attrs:{"color":"error","multi-line":"","timeout":-1},model:{value:(_vm.unauthorised),callback:function ($$v) {_vm.unauthorised=$$v},expression:"unauthorised"}},[_c('v-icon',{staticClass:"mr-4",attrs:{"large":""}},[_vm._v("error")]),_vm._v("\n    "+_vm._s(_vm.unauthorisedMsg)+"\n    "),_c('v-btn',{attrs:{"dark":"","text":""},on:{"click":function($event){_vm.unauthorised = false}}},[_vm._v("\n      Close\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 265:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user && __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.company) {
    next();
  } else {
    next('/signin');
  }
});

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_database__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_firebase_auth__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);






/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null,
    company: null,
    disclaimerAccepted: false,
    disclaimerText: {},
    disclaimerLanguage: 'English',
    languages: [],
    loginTime: null,
    timeout: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    },
    setCompany: function setCompany(state, payload) {
      state.company = payload ? payload.toLowerCase() : payload;
    },
    setDisclaimerAccepted: function setDisclaimerAccepted(state, payload) {
      state.disclaimerAccepted = payload;
    },
    setDisclaimerText: function setDisclaimerText(state, payload) {
      state.disclaimerText = payload;
    },
    setDisclaimerLanguage: function setDisclaimerLanguage(state, payload) {
      state.disclaimerLanguage = payload;
    },
    setLanguages: function setLanguages(state, payload) {
      state.languages = payload;
    },
    setLoginTime: function setLoginTime(state, payload) {
      state.loginTime = payload;
    },
    setTimeout: function setTimeout(state, payload) {
      state.timeout = payload;
    }
  },
  actions: {
    signUserIn: function signUserIn(_ref, payload) {
      var commit = _ref.commit,
          dispatch = _ref.dispatch;

      var userObj = {
        empID: payload.empID,
        fname: payload.fname,
        sname: payload.sname,
        pin: payload.pin
      };
      commit('setUser', userObj);
      commit('setLoginTime', __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss'));
      if (payload.timeout > 0) {
        commit('setTimeout', payload.timeout);
      } else {
        commit('setTimeout', null);
      }
    },
    checkCompany: function checkCompany(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setCompany', payload);
    },
    logout: function logout(_ref3) {
      var commit = _ref3.commit;

      commit('setUser', null);
      commit('setLoginTime', null);
    },
    fetchDisclaimerAccepted: function fetchDisclaimerAccepted(_ref4) {
      var commit = _ref4.commit,
          getters = _ref4.getters;

      var company = this.getters.company;
      var user = this.getters.user;
      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["database"]().ref(company + '/disclaimers/' + user.empID).once('value').then(function (data) {
        var obj = data.val();
        if (obj && obj.accepted) {
          commit('setDisclaimerAccepted', obj.accepted);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    acceptDisclaimer: function acceptDisclaimer(_ref5) {
      var commit = _ref5.commit,
          getters = _ref5.getters;

      var company = this.getters.company;
      var user = this.getters.user;
      var obj = {
        accepted: true,
        date: new Date().toISOString()
      };
      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["database"]().ref(company + '/disclaimers/' + user.empID).update(obj).then(function (data) {
        console.log(data);
        commit('setDisclaimerAccepted', true);
      }).catch(function (error) {
        console.log(error);
      });
    },
    fetchDisclaimerText: function fetchDisclaimerText(_ref6) {
      var commit = _ref6.commit,
          getters = _ref6.getters;

      var company = this.getters.company;
      if (localStorage.getItem('disclaimerText') !== null && localStorage.getItem('disclaimerText') !== undefined && localStorage.getItem('languages') !== null && localStorage.getItem('languages') !== undefined) {
        commit('setDisclaimerText', JSON.parse(localStorage.getItem('disclaimerText')));
        commit('setLanguages', JSON.parse(localStorage.getItem('languages')));
      }
      __WEBPACK_IMPORTED_MODULE_1_firebase_app__["database"]().ref(company + '/disclaimerText').once('value').then(function (data) {
        var obj = data.val();
        var languages = [];
        for (var language in obj) {
          languages.push(language);
        }
        if (obj) {
          commit('setDisclaimerText', obj); // obj.accepted should always be true if set so we'll be setting disclaimer to false
          localStorage.setItem('disclaimerText', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
        }
        if (languages) {
          localStorage.setItem('languages', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(languages));
          commit('setLanguages', languages);
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setDisclaimerLanguage: function setDisclaimerLanguage(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setDisclaimerLanguage', payload);
    },
    setLoginTime: function setLoginTime(_ref8, payload) {
      var commit = _ref8.commit;

      commit('setLoginTime', payload);
    },
    checkLoginTime: function checkLoginTime(_ref9) {
      var dispatch = _ref9.dispatch,
          state = _ref9.state,
          rootState = _ref9.rootState;

      var timeout = state.timeout + 15;
      var loginTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()(state.loginTime, 'YYYY-MM-DD HH:mm:ss');
      var diff = __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(loginTime, 'm');
      var diffText = __WEBPACK_IMPORTED_MODULE_4_moment___default()().to(loginTime);
      if (timeout && diff >= timeout) {
        console.log('Login timed out');
        var company = this.getters.company;
        var user = this.getters.user;
        __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(rootState.shared.url + '/dms-service/clockoutLongShift.ajax.php', { emp_id: user.empID, now: __WEBPACK_IMPORTED_MODULE_4_moment___default()().format('YYYY-MM-DD HH:mm:ss'), company: company }).then(function (result) {
          console.log(result);
          dispatch('logout');
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        console.log('Logged in ' + diffText + ', login timeouts after ' + timeout + ' minutes.');
      }
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    },
    company: function company(state) {
      return state.company;
    },
    disclaimerAccepted: function disclaimerAccepted(state) {
      return state.disclaimerAccepted;
    },
    disclaimerText: function disclaimerText(state, getters) {
      return state.disclaimerText[getters.disclaimerLanguage];
    },
    disclaimerLanguage: function disclaimerLanguage(state) {
      return state.disclaimerLanguage;
    },
    languages: function languages(state) {
      return state.languages;
    },
    loginTime: function loginTime(state) {
      return state.loginTime;
    }
  }
});

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dbPromise__ = __webpack_require__(276);


/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    timesheet: []
  },
  mutations: {
    setTimesheetData: function setTimesheetData(state, payload) {
      state.timesheet = payload;
    }
  },
  actions: {
    fetchTimesheet: function fetchTimesheet(_ref) {
      var commit = _ref.commit,
          getters = _ref.getters;

      commit('setLoading', true);
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(getters.url + '/dms-service/getShiftsForEmp.ajax.php', {
        emp: getters.user.empID,
        company: getters.company
      }).then(function (response) {
        commit('setLoading', false);
        var data = response.data;
        commit('setTimesheetData', data);
        Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('timesheet-archive', 'readwrite');
          var timesheetStore = tx.objectStore('timesheet-archive');
          timesheetStore.put(data, getters.user.empID);
          return tx.complete;
        }).then(function () {
          console.log('data saved locally');
        });
      }).catch(function (e) {
        Object(__WEBPACK_IMPORTED_MODULE_1__dbPromise__["a" /* default */])().then(function (db) {
          var tx = db.transaction('timesheet-archive');
          var timesheetStore = tx.objectStore('timesheet-archive');
          return timesheetStore.get(getters.user.empID);
        }).then(function (val) {
          commit('setLoading', false);
          if (val !== undefined) {
            commit('setTimesheetData', val);
          }
        });
      });
    }
  },
  getters: {
    timesheet: function timesheet(state) {
      return state.timesheet;
    }
  }
});

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dbPromise;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_idb__);


function dbPromise() {
  var dbPromise = __WEBPACK_IMPORTED_MODULE_0_idb___default.a.open('dms-db', 1, function (upgradeDb) {
    switch (upgradeDb.oldVersion) {
      case 0:
        upgradeDb.createObjectStore('outbox-timesheets', { autoIncrement: true });
        upgradeDb.createObjectStore('outbox-receipts');
        upgradeDb.createObjectStore('timesheet-archive');
        upgradeDb.createObjectStore('image-store');
        upgradeDb.createObjectStore('current-expenses');
    }
  });

  return dbPromise;
}

/***/ }),

/***/ 277:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null,
    GPS: null,
    url: 'https://cwelite.aquariusit.com',
    versions: {
      app: null,
      db: null
    },
    appOutdated: false,
    applicationMode: localStorage.getItem('applicationMode') !== null && localStorage.getItem('applicationMode') !== undefined ? localStorage.applicationMode : 'dms',
    signoutInterval: localStorage.getItem('signoutInterval') !== null && localStorage.getItem('signoutInterval') !== undefined ? localStorage.signoutInterval : 0
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    },
    setGPS: function setGPS(state, payload) {
      state.GPS = payload;
    },
    setURL: function setURL(state, payload) {
      state.url = payload;
    },
    setApplicationMode: function setApplicationMode(state, payload) {
      state.applicationMode = payload;
    },
    appOutdated: function appOutdated(state, payload) {
      state.appOutdated = payload;
    },
    setSignoutInterval: function setSignoutInterval(state, payload) {
      state.signoutInterval = payload;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    },
    setLoading: function setLoading(_ref2, payload) {
      var commit = _ref2.commit;

      commit('setLoading', payload);
    },
    getLocation: function getLocation(_ref3) {
      var commit = _ref3.commit;

      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          commit('setGPS', position);
        }, function (error) {
          commit('setGPS', error);
        });
      } else {
        commit('setGPS', null);
      }
    },
    setURL: function setURL(_ref4, payload) {
      var commit = _ref4.commit;

      commit('setURL', payload);
    },
    setApplicationMode: function setApplicationMode(_ref5, payload) {
      var commit = _ref5.commit;

      commit('setApplicationMode', payload);
    },
    appOutdated: function appOutdated(_ref6, payload) {
      var commit = _ref6.commit;

      commit('appOutdated', payload);
    },
    setSignoutInterval: function setSignoutInterval(_ref7, payload) {
      var commit = _ref7.commit;

      commit('setSignoutInterval', payload);
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    },
    GPS: function GPS(state) {
      return state.GPS;
    },
    url: function url(state) {
      return state.url;
    },
    applicationMode: function applicationMode(state) {
      return state.applicationMode;
    },
    appOutdated: function appOutdated(state) {
      return state.appOutdated;
    },
    signoutInterval: function signoutInterval(state) {
      return state.signoutInterval;
    }
  }
});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    currencyData: {}
  },
  mutations: {
    setCurrencyData: function setCurrencyData(state, payload) {
      state.currencyData = payload;
    }
  },
  actions: {
    setCurrencyData: function setCurrencyData(_ref, payload) {
      var commit = _ref.commit;

      commit('setCurrencyData', payload);
    }
  },
  getters: {
    currency: function currency(state) {
      return state.currencyData;
    }
  }
});

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(35);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (!__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user || !__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.company) {
    next();
  } else {
    next('/');
  }
});

/***/ }),

/***/ 281:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 282:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 35:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timesheet__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__expenses__ = __webpack_require__(278);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    timesheet: __WEBPACK_IMPORTED_MODULE_3__timesheet__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_4__shared__["a" /* default */],
    expenses: __WEBPACK_IMPORTED_MODULE_5__expenses__["a" /* default */]
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      drawer: false,
      fixed: false,
      connected: true,
      disclaimer: false
    };
  },
  created: function created() {},

  computed: {
    user: function user() {
      return this.$store.getters.user;
    },
    appOutdated: function appOutdated() {
      return this.$store.getters.appOutdated;
    },
    applicationMode: function applicationMode() {
      return this.$store.getters.applicationMode;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
    },
    onLogout: function onLogout() {
      this.$store.dispatch('logout');
      this.$router.push('/SignIn');
    },
    showDisclaimer: function showDisclaimer() {
      this.disclaimer = true;
    },
    resetApp: function resetApp() {
      navigator.serviceWorker.getRegistrations().then(function (registrations) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(registrations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var registration = _step.value;

            registration.unregister();
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }).then(function (boolean) {
        caches.delete('dms-cache').then(function (boolean) {
          window.location.reload(true);
        });
      });
    }
  }
});

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      snackbar: false,
      snackbarText: '',
      currentJob: false,
      snackbarTimeout: 1000,
      company: this.$store.getters.company,
      timer: this.$store.getters.signoutInterval * 60,
      timerDefault: this.$store.getters.signoutInterval * 60,
      acknowledgedFiles: [],
      unacknowledgedFiles: [],
      dialog: false,
      activeType: null,
      confirmCheckbox: false,
      activeFile: null,
      activeTime: null,
      viewingTime: null,
      emp_id: this.$store.getters.user.empID,
      activeAcknowledgedFolder: null,
      activeUnacknowledgedFolder: null,
      loading: false,
      viewFileDialog: false,
      pdfLoaded: false,
      totalPages: 0,
      quizList: [],
      dialogQuiz: false,
      alertDialog: false,
      alertMessage: '',
      alertResolve: null
    };
  },
  created: function created() {
    this.getFiles();
    this.getQuizList();
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener('focus', function () {
      _this.getFiles();
    });
    this.$store.dispatch('checkLoginTime');
    if (this.timer > 0) {
      var interval = setInterval(function () {
        _this.timer--;
        if (_this.timer === 0) {
          _this.$store.dispatch('logout');
          clearInterval(interval);
        }
      }, 1000);
    }
  },

  methods: {
    getQuizList: function getQuizList() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.url + '/dms-service/get-quizzes.ajax.php', {
        company: this.company
      }).then(function (res) {
        if (res.data.status) {
          _this2.quizList = res.data.quizzes;
        }
      });
    },
    getQuiz: function getQuiz(file) {
      return this.quizList.find(function (q) {
        return q.quiz_id === file.quiz_id;
      });
    },
    zeroFill: function zeroFill(number, width) {
      width -= number.toString().length;
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number;
      }
      return number;
    },
    closeViewFileDialog: function closeViewFileDialog() {
      console.log(this.activeFile);
      this.viewFileDialog = false;
      if (this.activeType === 'unacknowledged') {
        this.dialog = true;
      }
    },

    // This currently always is sent from file as this was made from documents, but when quizzes are able to be applied directly to an employee,
    // send to this function as false to avoid the other end trying to unacknowledge a file that doesnt exist.
    setActiveFile: function setActiveFile(file, type) {
      var _this3 = this;

      var sentFromFile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      console.log('FILE CLICKED:', file);
      this.activeFile = file;
      this.activeType = type;
      if (file.item_name === 'Quizzes') {
        var quiz = this.getQuiz(file);
        if (sentFromFile === true) {
          if (quiz) {
            console.log(quiz);
            window.open(file.fileref + '&v=' + file.quiz_version_id + '&fromFileAcknowledgement=true', '_blank');
            return;
          } else {
            this.snackbarText = 'Quiz not found';
            this.snackbar = true;
            return;
          }
        } else {
          if (quiz) {
            console.log(quiz);
            window.open(file.fileref + '&v=' + file.quiz_version_id, '_blank');
            return;
          } else {
            this.snackbarText = 'Quiz not found';
            this.snackbar = true;
            return;
          }
        }
      }
      var proceed = function proceed() {
        if (type === 'unacknowledged') {
          _this3.activeTime = __WEBPACK_IMPORTED_MODULE_4_moment___default()();
          _this3.confirmCheckbox = false;
        }
        if (file.interactive) {
          window.open(file.fileref);
          return;
        }
        _this3.viewFileDialog = true;
      };
      if (type === 'unacknowledged' && file.intro_message) {
        this.showAlert(file.intro_message).then(proceed);
      } else {
        proceed();
      }
    },
    showAlert: function showAlert(message) {
      var _this4 = this;

      this.alertMessage = message;
      this.alertDialog = true;
      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
        _this4.alertResolve = resolve;
      });
    },
    confirmAlert: function confirmAlert() {
      this.alertDialog = false;
      var resolve = this.alertResolve;
      this.alertResolve = null;
      if (resolve) resolve();
    },
    getFiles: function getFiles() {
      var _this5 = this;

      this.loading = true;
      return __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.url + '/dms-service/get-files-by-emp.ajax.php', {
        company: this.company,
        emp_id: this.emp_id
      }).then(function (response) {
        _this5.acknowledgedFiles = response.data.acknowledged;
        _this5.unacknowledgedFiles = response.data.unacknowledged;

        return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
          setTimeout(function () {
            _this5.loading = false;
            if (_this5.unacknowledgedFolders.findIndex(function (f) {
              return f.folderName === _this5.activeUnacknowledgedFolder;
            }) === -1) {
              _this5.activeUnacknowledgedFolder = null;
            }
            resolve();
          }, 200);
        });
      });
    },
    acknowledgeFile: function acknowledgeFile() {
      var _this6 = this;

      this.viewingTime = this.activeTime ? __WEBPACK_IMPORTED_MODULE_4_moment___default()().diff(this.activeTime, 's') : null;
      var file = this.activeFile;
      file.viewingTime = this.viewingTime;
      file.emp_id = this.emp_id;
      file.company = this.company;
      __WEBPACK_IMPORTED_MODULE_5_axios___default.a.post(this.url + '/dms-service/acknowledge-file.ajax.php', file).then(function (response) {
        _this6.activeTime = null;
        _this6.dialog = false;
        return _this6.getFiles();
      }).then(function () {
        _this6.completeQuizPrompt();
      });
    },
    completeQuizPrompt: function completeQuizPrompt() {
      if (this.activeFile && this.activeFile.quiz_id) {
        this.dialogQuiz = true;
      }
    },
    takeQuizNow: function takeQuizNow() {
      var _this7 = this;

      this.dialogQuiz = false;
      var quizFile = this.unacknowledgedFiles.find(function (f) {
        return f.type === 'quiz' && f.quiz_id === _this7.activeFile.quiz_id;
      });
      this.setActiveFile(quizFile, 'unacknowledged', true);
    }
  },
  computed: {
    fullname: function fullname() {
      return this.$store.getters.user ? this.$store.getters.user.fname + ' ' + this.$store.getters.user.sname : '';
    },
    url: function url() {
      return this.$store.getters.url;
    },
    acknowledgedFolders: function acknowledgedFolders() {
      var folderArray = [];

      var _loop = function _loop(file) {
        var index = folderArray.findIndex(function (f) {
          return f.folderName === file.item_name;
        });
        if (index === -1) {
          folderArray.push({ folderName: file.item_name, count: 1, item_id: file.item_id });
        } else {
          folderArray[index].count++;
        }
      };

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.acknowledgedFiles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var file = _step.value;

          _loop(file);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (folderArray.length === 1) {
        this.activeAcknowledgedFolder = folderArray[0].folderName;
      }
      return folderArray;
    },
    filteredAcknowledgedFiles: function filteredAcknowledgedFiles() {
      var _this8 = this;

      var acknowledgedFiles = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.acknowledgedFiles));
      return acknowledgedFiles.filter(function (f) {
        return f.item_name === _this8.activeAcknowledgedFolder;
      });
    },
    unacknowledgedFolders: function unacknowledgedFolders() {
      var folderArray = [];

      var _loop2 = function _loop2(file) {
        var index = folderArray.findIndex(function (f) {
          return f.folderName === file.item_name;
        });
        if (index === -1) {
          folderArray.push({ folderName: file.item_name, count: 1, item_id: file.item_id });
        } else {
          folderArray[index].count++;
        }
      };

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(this.unacknowledgedFiles), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var file = _step2.value;

          _loop2(file);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (folderArray.length === 1) {
        this.activeUnacknowledgedFolder = folderArray[0].folderName;
      }
      return folderArray;
    },
    filteredUnacknowledgedFiles: function filteredUnacknowledgedFiles() {
      var _this9 = this;

      var unacknowledgedFiles = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(this.unacknowledgedFiles));
      return unacknowledgedFiles.filter(function (f) {
        return f.item_name === _this9.activeUnacknowledgedFolder;
      });
    },
    logoutCountdown: function logoutCountdown() {
      var d = this.timer;
      d = Number(d);
      var h = this.zeroFill(Math.floor(d / 3600), 2);
      var m = this.zeroFill(Math.floor(d % 3600 / 60), 2);
      var s = this.zeroFill(Math.floor(d % 3600 % 60), 2);

      return h + ':' + m + ':' + s;
    }
  },
  filters: {
    formatDate: function formatDate(val) {
      return val !== undefined ? __WEBPACK_IMPORTED_MODULE_4_moment___default()(val).format('DD/MM/YYYY HH:mm') : '--';
    },
    formatPercentage: function formatPercentage(val) {
      if (val === undefined) return '--';
      var num = Number(val);
      if (isNaN(num)) return val;
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(num) || num % 1 === 0) return num.toString();
      if (num.toFixed(2).endsWith('.00')) return Math.round(num).toString();
      return num.toFixed(2);
    }
  }
});

/***/ })

},[190]);


// WEBPACK FOOTER //
// static/js/app.1b4e6f35ce075d521f45.js